import { useQuery } from '@tanstack/react-query'
import { getWhoami } from 'api/admin/userPermissions/getWhoami'
import { userPermissionsKeys } from './keys'

export function useWhoamiQuery() {
  return useQuery({
    queryKey: userPermissionsKeys.whoami(),
    queryFn: getWhoami,
  })
}
